<template>
    <div class="container">
        <div class="page">
            <div class="header">
                <div class="left">
                    <img src="../../assets/images/pay-success.png" alt="" class="icon-success">
                </div>
                <p class="right">
                    支付成功  感谢您的支持<br/>
                    <span class="tip">您定制的款式我们将尽快为您安排生产，请您耐心等待</span><br/>
                    <span class="tip red" v-if="detail.is_need_send_back">当前订单需要您寄出客供面料或辅料，请及时填写物流信息</span>
                </p>
            </div>
            <div class="content">
                <div class="info-wrap">
                    <p class="price">订单金额：<span class="money">￥{{detail.total_price}}</span></p>
                    <p class="address">收件信息：{{detail.province}}{{detail.city}}{{detail.zone}}{{detail.address}}  {{detail.contact_person}}  {{detail.contact_mobile}}</p>
                </div>

                <div class="btn-group">
                    <div class="btn btn-see" @click="go2detail">查看订单</div>
                </div>
            </div>
        </div>
    	<Chat ref="chat"></Chat>

    </div>
</template>

<script>
    import {
        OrderDetail,
    } from "@/api/index.js"
    export default {
        name: "PayResult",
        components: {},
        data() {
            return {
                uuid: '',
                detail: {
                    design: {}
                },
            }
        },
        methods: {
            go2detail() {
                this.$router.replace({name: 'OrderDetail', query: {uuid: this.uuid}})
            },
        },
        mounted() {
            this.uuid = this.$route.query.uuid
            if(this.$route.query.uuid) {
                OrderDetail({
                    uuid: this.$route.query.uuid
                }).then(response => {
                    this.detail = response.data
                    this.$refs.chat.showChat(null,this.detail.order_no,this.detail.mtm.design_data.category.image,this.detail.mtm.design_data.style_number);
                })
            }
        },
    }
</script>

<style scoped lang="scss">
    .container {
        background: #F6F7FA;
        padding: 30px 200px 100px 200px;
        .page {
            width: 1500px;
            height: 600px;
            margin: 0 auto;
            padding:0 70px;
            background: white;
            border-radius: 10px 10px 10px 10px;
            .header {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 65px 0;
                border-bottom: 1px solid #DBDBDB;
                color: #333;
                .left {
                    .icon-success {
                        width: 56px;
                        height: 56px;
                    }
                }

                .right {
                    margin-left: 20px;
                    color: #1A1A1A;
                    font-size: 26px;
                    font-weight: bold;
                    .tip {
                        font-weight: normal;
                        color: #4D4D4D;
                        font-size: 16px;
                    }
                    .red {
                        color: red;
                        font-size: 14px;
                        font-weight: bold;
                    }
                }
            }

            .content {
                margin-top: 46px;
                .info-wrap {
                    padding: 40px;
                    background: #F7F7F7;
                    .price {
                        color: #1A1A1A;
                        font-weight: bold;
                        font-size: 14px;
                        .money {
                            color: #FA3D5A;
                            font-size: 24px;
                        }
                    }
                    .address {
                        color: #4D4D4D;
                        font-size: 14px;
                    }

                }
                .btn-group {
                    margin-top: 44px;
                    font-size: 14px;
                    .btn {
                        width: 120px;
                        height: 42px;
                        line-height: 42px;
                        border-radius: 5px 5px 5px 5px;
                        text-align: center;
                        cursor: pointer;
                        &.btn-see {
                            background: #FA3D5A;
                            color: white;
                        }
                    }
                }
            }
        }
    }
</style>
